import { render } from "./ViewFree.vue?vue&type=template&id=3248bbb9&scoped=true"
import script from "./ViewFree.vue?vue&type=script&lang=js"
export * from "./ViewFree.vue?vue&type=script&lang=js"

import "./ViewFree.vue?vue&type=style&index=0&id=3248bbb9&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3248bbb9"]])

export default __exports__